export async function stationShowUseCase(showStationData, stationRepository) {

    const result = await stationRepository.show(showStationData);

    const entity = new stationRepository.model(result);
    
    if (!entity.isValid()) {
      throw new Error("Estación inválido");
    }

    return entity;
}